import appState from "@/appState.js";
import webSafeImageMimeTypes from "@/data/webSafeImageMimeTypes.js";

export default function (blob, fileName, options = { forceDownload: false, carousel: null }) {
  const fileExtension = fileName.split(".").pop();
  const isImage = webSafeImageMimeTypes.includes(blob.type);
  const isPdf = ["application/pdf"].includes(blob.type) || fileExtension === "pdf";

  // fixes .pdf files that have "application/octet-stream" as their mime type (looking at you, shipstation)
  if (fileExtension === "pdf" && blob.type !== "application/pdf") blob = new Blob([blob], {type: "application/pdf" });

  if ((isImage || isPdf) && !options.forceDownload) {
    appState.fileViewerDialog = { isVisible: true, blob, fileName, carousel: options.carousel };
 } else {
    const fileURL = window.URL.createObjectURL(new Blob([blob]));
    const fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
  }

};